import * as React from 'react';
import { cloneElement, isValidElement, ReactElement } from 'react';
import { Typography, styled } from '@mui/material';
import { DataNode } from 'rc-tree/lib/interface';
import { NodeActionsProps } from './NodeActions';
import { RecordContextProvider } from 'react-admin';

const NodeTitle = (props: NodeTitleProps): ReactElement => {
    const { data, nodeActions, ...rest }: any = props;
    return (
        <RecordContextProvider value={data}>
            <Root {...rest}>
                <Typography variant="body1">{data.title}</Typography>
                {isValidElement(nodeActions) &&
                    cloneElement<any>(nodeActions, {
                        className: NodeTitleClasses.menuButton,
                        data,
                    })}
            </Root>
        </RecordContextProvider>
    );
};

export interface NodeTitleProps {
    data: DataNode;
    nodeActions?: ReactElement<NodeActionsProps>;
}

export default NodeTitle;

const PREFIX = 'RaNodeTitle';

export const NodeTitleClasses = {
    menuButton: `${PREFIX}-menuButton`,
};

const Root = styled('div', {
    name: PREFIX,
    overridesResolver: (props, styles) => styles.root,
})(({ theme }) => ({
    position: 'relative',
    display: 'flex',
    width: '100%',
    height: '100%',
    alignItems: 'center',
    overflowY: 'hidden',
    [`& .MuiTypography-root`]: {
        flex: '1 1 auto',
    },
    '&:hover': {
        [`& .${NodeTitleClasses.menuButton} button`]: {
            opacity: 1,
        },
    },
    [`& .${NodeTitleClasses.menuButton} button`]: {
        flex: '0 0 auto',
        display: 'flex',
        alignItems: 'center',
        height: '100%',
        background: 'transparent',
        border: 'none',
        opacity: 0,
        outline: 'none',
        marginLeft: theme.spacing(1),
        '&:focus': {
            opacity: 1,
        },
    },
}));
